export const appendFile = file => {
  const formData = new FormData();
  formData.append("file", file);
  return formData;
};